import { motion } from "framer-motion"
import { useConsole } from "contexts/Console"
import styled from "@emotion/styled"
import { headline100, surtitle70 } from "css/text"
import getMediaQuery from "css/breakpoints"
import hash from "@emotion/hash"
import OysterStoryLogo from "components/oyster-story-logo/OysterStoryLogo"

export const cssHgroup = `css-${hash("hgroup")}`

const Hgroup = styled(motion.hgroup)`
  align-self: center;
  display: grid;
  grid-template-rows: repeat(2, min-content);
  height: fit-content;
  text-align: center;

  & > h2,
  & > p {
    text-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
  }

  & > h2 {
    grid-row-start: 2;
  }

  & > p {
    ${surtitle70}
    grid-row-start: 1;
    margin-block-end: 10px;
  }

  & > svg {
    grid-row-start: 2;
    width: calc(var(--grid-col-unit) * 4);

    ${getMediaQuery("m")} {
      width: calc(var(--grid-col-unit) * 6);
    }
    ${getMediaQuery("l")} {
      width: calc(var(--grid-col-unit) * 4);
    }
  }
`

const Title = styled(motion.h2)`
  ${headline100}
  margin-bottom: -0.7rem;
  padding-bottom: 0.7rem;

  ${getMediaQuery("m")} {
    margin-bottom: -0.7rem;
    padding-bottom: 0.7rem;
  }
`

const kickerVariants = {
  show: {
    opacity: 1,
    transition: { duration: 0.55, ease: "easeOut", delay: 0.35 },
  },
  pre: {
    opacity: 0,
  },
  hide: {
    opacity: 0,
    transition: { duration: 0.45, ease: "easeOut" },
  },
}

const titleVariants = {
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: "easeOut" },
  },
  pre: {
    opacity: 0,
    y: 22,
  },
  hide: {
    opacity: 0,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
}

export default function Heading({ title, kicker, animate = "show", use_os_logo, animated_logo }) {
  const console = useConsole()

  return (
    <Hgroup className={cssHgroup}>
      {kicker && (
        <motion.p initial='pre' animate={animate} variants={kickerVariants}>
          {kicker}
        </motion.p>
      )}
      {use_os_logo ? (
        <OysterStoryLogo animated_logo={animated_logo} />
      ) : (
        title && <Title initial='pre' animate={animate} variants={titleVariants} dangerouslySetInnerHTML={{ __html: title }} />
      )}
    </Hgroup>
  )
}
